const environmentLive = {
  apiUrl: 'https://api.andreawazen.com',
};
function newsletterModal(isShow, timer) {
  if (!isShow) {
    return;
  }

  let modal;

  document.addEventListener('click', (e) => {
    // Open the modal when clicked on the below class element
    if (e.target.className === 'modal-open') {
      modal = document.getElementById(e.target.dataset.id);

      openModal(modal);
    }
    // Close the modal when clicked on the below class element - Close the modal when clicked out the modal
    else if (e.target.className === 'aw-newsletter-modal-close' || e.target == modal) {
      closeModal(modal, false);
    } else if (e.target.id == 'aw-newsletter-submit-btn') {
      e.preventDefault();
      emailValidation();
    } else {
      return;
    }
    // else if (e.target.id == 'aw-newsletter-submit-btn-footer'){
    //   e.preventDefault();
    //   emailValidationFooter();
    // } 
  });

  //  const emailValidationFooter = () => {
  //   const getSubscriberEmail = document.getElementById('aw-newsletter-email-footer').value;
  //   const errorText = document.getElementById('aw-error-footer');

  //   if (getSubscriberEmail.length === 0) {
  //     errorText.style.display = 'block';
  //     errorText.innerHTML = 'Please provide an email address';
  //     return;
  //   } else {
  //     // check for valid email format
  //     let emailRegex = /\S+@\S+\.\S+/;
  //     let isValid = emailRegex.test(getSubscriberEmail);

  //     if (!isValid) {
  //       errorText.style.display = 'block';
  //       errorText.innerHTML = 'Please provide an valid email address';
  //       return;
  //     } else {
  //       createSubscriberFooter();
  //     }
  //   }
  // };

  const emailValidation = () => {
    const getSubscriberEmail = document.getElementById('aw-newsletter-email').value;
    const errorText = document.getElementById('aw-error');

    if (getSubscriberEmail.length === 0) {
      errorText.style.display = 'block';
      errorText.innerHTML = 'Please provide an email address';
      return;
    } else {
      // check for valid email format
      let emailRegex = /\S+@\S+\.\S+/;
      let isValid = emailRegex.test(getSubscriberEmail);

      if (!isValid) {
        errorText.style.display = 'block';
        errorText.innerHTML = 'Please provide an valid email address';
        return;
      } else {
        createSubscriber();
      }
    }
  };

  // const createSubscriberFooter = () => {
  //   const getSubscriberEmail = document.getElementById('aw-newsletter-email-footer').value;
  //   const endPoint = environmentLive.apiUrl + '/api/shopify/newsletter';
  //   const data = {
  //     email: getSubscriberEmail,
  //     // source: 'Newsletter Footer',
  //   };

  //   const options = {
  //     method: 'POST',
  //     headers: {
  //       Accept: 'application/json',
  //       'Content-Type': 'application/json',
  //     },
  //     body: JSON.stringify(data),
  //   };

  //   fetch(endPoint, options)
  //     .then((response) => {
  //       if (response.status === 409) {
  //         return { status: 409 };
  //       }
  //       return response.json();
  //     })
  //     .then((response) => subscriptionSuccess(response))
  //     .catch((err) => subscriptionError(err));
  // };
  
  const createSubscriber = () => {
    const getSubscriberEmail = document.getElementById('aw-newsletter-email').value;
    const endPoint = environmentLive.apiUrl + '/api/shopify/newsletter';
    const data = {
      email: getSubscriberEmail,
      // source: 'Newsletter Modal',
    };

    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    };

    fetch(endPoint, options)
      .then((response) => {
        if (response.status === 409) {
          return { status: 409 };
        }
        return response.json();
      })
      .then((response) => subscriptionSuccess(response))
      .catch((err) => subscriptionError(err));
  };

  const subscriptionSuccess = (response) => {
    if (response.message === "Already subscribed") {
      subscriptionError(response);
      return;
    }

    const getSubscriberEmail = document.getElementById('aw-newsletter-email');
    getSubscriberEmail.value = '';

    showThankyouScreen();
  };

  const subscriptionError = (err) => {
    const errorText = document.getElementById('aw-error');
    errorText.style.display = 'block';
    errorText.innerHTML = 'This email address is already subscribed.';
  };

  const showThankyouScreen = () => {
    //Remove the existing constent
    const errorText = document.getElementById('aw-error');
    errorText.style.display = 'block';
    errorText.innerHTML = 'Thank you for subscribing, please check your email for the coupon!';

    setTimeout(() => {
      modal = document.getElementById('aw-newsletter-modal');
      closeModal(modal, true);

      errorText.style.display = 'none';
      errorText.innerHTML = '';
    }, 4000);
  };

  const openModal = (modal) => {
    document.body.style.overflow = 'hidden';
    modal.setAttribute('open', 'true');
    document.addEventListener('keydown', escClose);
  };

  const setCookie = (name, value, days) => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  };

  const getCookie = (cname) => {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  const closeModal = (modal, hideForAMonth) => {
    document.body.style.overflow = 'auto';
    modal.removeAttribute('open');
    document.removeEventListener('keydown', escClose);

    if (hideForAMonth) {
      setCookie('NewsletterModalPref', 'hide', 30);
    } else {
      sessionStorage.setItem('NewsletterModalPref', 'hide');
    }
  };

  const escClose = (e) => {
    if (e.keyCode == 27) {
      closeModal(modal, false);
    }
  };

  // Auto open the modal after 2sec when whole page is loaded
  window.addEventListener('load', (event) => {
    let getModalPref =
      sessionStorage.getItem('NewsletterModalPref') || getCookie('NewsletterModalPref') == 'hide' ? true : false;
    let isAdminLoggedIn = $('body').hasClass('hasAdminBar');
    let isLoadedFromIFrame;

    // Is the page loaded from a iframe, for page builder
    if (window.self !== window.top) {
      isLoadedFromIFrame = true;
    } else {
      isLoadedFromIFrame = false;
    }

    if (isAdminLoggedIn) {
      return console.log('Newsletter Modal: Logged in user, Subscription modal disabled!');
    } else if (isLoadedFromIFrame) {
      return console.log('Newsletter Modal: Is loaded from iFrame!');
    } else if (getModalPref) {
      if (sessionStorage.getItem('NewsletterModalPref') == 'hide') {
        console.log('Newsletter Modal: Session level Disabled!');
      } else if (getCookie('NewsletterModalPref') == 'hide') {
        console.log('Newsletter Modal: Subscribed level Disabled!');
      }
      return;
    }

    setTimeout(() => {
      modal = document.getElementById('aw-newsletter-modal');
      openModal(modal);
    }, timer);
  });

  const getSubscriberEmail = document.getElementById('aw-newsletter-email');
  getSubscriberEmail.addEventListener('keyup', (event) => {
    const errorText = document.getElementById('aw-error');

    console.log(errorText.textContent);

    if (event.key === 'Enter') {
      return;
    }

    if (errorText.textContent.length == 0) {
      return;
    }

    errorText.innerHTML = '';
    errorText.style.display = 'none';
  });
}

function footerNewsletter() {
  const emailInput = document.getElementById('aw-newsletter-email-footer');
  const submitBtn = document.getElementById('aw-newsletter-submit-btn-footer');
  const errorText = document.getElementById('aw-error-footer');
  // Clear error on typing
  emailInput.addEventListener('input', () => {
    errorText.style.display = 'none';
    errorText.innerHTML = '';
  });
  submitBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const email = emailInput.value.trim();
    // Validation
    if (!email) {
      errorText.style.display = 'block';
      errorText.innerHTML = 'Please provide an email address';
      return;
    }
    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(email)) {
      errorText.style.display = 'block';
      errorText.innerHTML = 'Please provide a valid email address';
      return;
    }
    // Create subscriber
    submitBtn.disabled = true; // Disable button while submitting
    fetch(environmentLive.apiUrl + '/api/shopify/newsletter', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    })
      .then((res) => {
        if (res.status === 409) return { status: 409 };
        return res.json();
      })
      .then((response) => {
        if (response.message === "Already subscribed") {
          errorText.style.display = 'block';
          errorText.innerHTML = 'This email address is already subscribed.';
        } else {
          emailInput.value = '';
          errorText.style.display = 'block';
          errorText.innerHTML =
            'Thank you for subscribing, please check your email for the coupon!';
          setTimeout(() => {
            errorText.style.display = 'none';
            errorText.innerHTML = '';
          }, 4000);
        }
      })
      .catch((err) => {
        console.error('Footer Newsletter Error:', err);
        errorText.style.display = 'block';
        errorText.innerHTML = 'An error occurred. Please try again.';
      })
      .finally(() => {
        submitBtn.disabled = false; // Re-enable button
      });
  });
}


newsletterModal(true, 3000);

// Initialize footer newsletter
footerNewsletter();
